import { TAGS_ACTIONS } from "../constants/actionsConstants";

const defaultTag = {
  id: 0,
  name: '',
  fontColor: '#FFFFFF',
  tagColor: '#000000'
};

const initialState = {
  tags: [],
  totalTags: 0,
  pages: 0,
  tagCreated: {},
  tag: defaultTag,
  loading: false,
  error: null
};

const tagsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'TAGS_LOADING_START':
      return {
        ...state,
        loading: true,
        error: null
      };
    case 'SET_ALL_TAGS':
      return {
        ...state,
        tags: action.data.tags,
        pages: action.data.pages,
        loading: false,
        error: null
      };
    case 'TAGS_LOADING_ERROR':
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case 'SET_CREATED_NEW_TAG':
      return {
        ...state,
        tagCreated: action.data.tag
      };
    case 'EMPTY_TAG_CREATED':
      return {
        ...state,
        tagCreated: {}
      };
    case 'TAGS_ALREADY_LOADED':
      return {
        ...state,
        loading: false,
        error: null
      };
    case TAGS_ACTIONS.SET_DEFAULT_CREATE_TAG_INPUTS:
      return {
        ...state,
        tag: defaultTag
      };
    case TAGS_ACTIONS.SET_DEFAULT_EDIT_TAG_INPUTS:
      return {
        ...state,
        tag: action.payload
      };
    case TAGS_ACTIONS.ADD_NEW_TAG:
      return {
        ...state,
        tags: [action.payload, ...state.tags]
      };
    case TAGS_ACTIONS.UPDATE_TAG: {
      const updatedTags = state.tags.map((tag) => {
        if (tag.id === action.payload.id) {
          return {
            ...tag,
            ...action.payload,
            label: action.payload.tag
          };
        }
        return tag;
      });

      return {
        ...state,
        tags: [...updatedTags]
      };
    }
    default:
      return state;
  }
};

export default tagsReducer;
